import axios from 'axios';

export default axios.create({
    baseURL: 'https://k-server-ewhw.onrender.com/krkn',
    headers: {
      'Content-Type': 'application/json',
    },
});